<div class="modal-header">
  <h4 class="modal-title">Report {{ReportModel.BusinessName}}</h4>
  <a href="javascript:void(0)" style="color: black;" data-dismiss="modal">
    <i class="fa fa-times" aria-hidden="true"></i>
  </a>
</div>
<div class="modal-body">
  <form [formGroup]="ReportBizForm" #rbForm="ngForm">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <h5>Reason*</h5>
          <select class="form-control" formControlName="ReasonID">
            <option value="" selected>Choose Reason</option>
            <option *ngFor="let item of ReportReasonList" [value]="item.DataValue">{{item.DataText}}</option>
          </select>
          <span *ngIf="rbForm.submitted && rBForm.ReasonID.errors" class="text-danger">
            <span *ngIf="rBForm.ReasonID.errors.required"> *required</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <h5>Preferred Contact Mode*</h5>
          <select class="form-control" formControlName="PreferredContactMode">
            <option value="" selected>Select Preferred Contact Mode</option>
            <option *ngFor="let item of ContactModeList" [value]="item.DataValue">{{item.Column1}}</option>
          </select>
          <span *ngIf="rbForm.submitted && rBForm.PreferredContactMode.errors" class="text-danger">
            <span *ngIf="rBForm.PreferredContactMode.errors.required"> *required</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <h5>Preferred Contact Time*</h5>
          <input type="text" formControlName="PreferredContactTime" class="form-control">
          <span *ngIf="rbForm.submitted && rBForm.PreferredContactTime.errors" class="text-danger">
            <span *ngIf="rBForm.PreferredContactTime.errors.required"> *required</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <h5>Remarks*</h5>
          <textarea formControlName="Remarks" class="form-control"></textarea>
          <span *ngIf="rbForm.submitted && rBForm.Remarks.errors" class="text-danger">
            <span *ngIf="rBForm.Remarks.errors.required"> *required</span>
          </span>
        </div>
      </div>
    </div>
    <div class="row" >
      <div class="col-md-12">
        <div id="reportForm" class="cManikgreCaptcha"></div>
        <span *ngIf="CaptchaInvalid" class="text-danger">
          <span> {{CaptchaMessage}}</span>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label id="lblReMessage" style="display: none;" class="alert alert-info"></label>
        <button type="submit" class="btn btn-primary" *ngIf="!ReportModel.IsSubmitted"
                (click)="SubmitForm();">
          Submit
        </button>
        <button class="btn btn-primary" *ngIf="ReportModel.IsSubmitted">
          <manik-button-loader></manik-button-loader>
        </button>
        <button type="button" id="btnClose1" class="btn btn-danger" data-dismiss="modal">Close</button>
      </div>
    </div>
    <!-- <app-visitor-handler *ngIf="!UserLoggedIn" [CountryID]="WebSiteMetaData.COUNTRYID" [PortalName]="WebSiteMetaData.PC" [PortalID]="WebSiteMetaData.PID" (visitorLoggedIn)="CheckUserLoggedIn();Emit();"></app-visitor-handler> -->
  </form>
</div>
